export const pillars = [
  {
    id: "leaders",
    navLabel: "Leaders",
    accent: "#3b82f6",
    ctaText: "#ffffff",
    icon: "Briefcase",
    kicker: "Executive Branding and Communications",
    title: "Vartalab for Founders and Leaders",
    intro:
      "For founders, CEOs and senior B2B leaders, visibility is no longer optional, it is the new business card. Vartalab becomes the communications arm of your company. We shape how you show up as a leader on LinkedIn, in newsletters and on video, while your company page tells the story of your customers, your people and the work you deliver. Together, the two build one connected ecosystem where every post, every newsletter and every video compounds into trust, credibility and pipeline.",
    ctaLabel: "Build my leadership brand",
    features: [
      {
        icon: "Target",
        title: "Personal Brand Strategy",
        description:
          "We define your point of view, your content pillars and the story only you can tell on LinkedIn.",
      },
      {
        icon: "PenLine",
        title: "Executive Ghostwriting",
        description:
          "Weekly posts, articles and comments written in your voice, reviewed and approved before anything goes live.",
      },
      {
        icon: "Mail",
        title: "Newsletter and Long Form Authority",
        description:
          "A branded newsletter that goes deeper than a post, positioning you as the leader your industry turns to.",
      },
      {
        icon: "Video",
        title: "Video and Podcast Presence",
        description:
          "Scripts, shoots and edits for talks, podcasts and short videos that carry your thinking beyond text.",
      },
      {
        icon: "Building2",
        title: "Company Page as a Brand Engine",
        description:
          "Customer wins, employee spotlights and delivery stories turn your company page into proof, not promotion.",
      },
      {
        icon: "Mic2",
        title: "B2B Leadership Visibility",
        description:
          "Speaking slots, panel positioning and industry conversations that place you where your buyers are already looking.",
      },
    ],
  },
  {
    id: "students",
    navLabel: "Students",
    accent: "#f5b335",
    ctaText: "#0b0d12",
    icon: "GraduationCap",
    kicker: "Career Branding and Campus Programs",
    title: "Vartalab for Students",
    intro:
      "Every recruiter checks LinkedIn before they check a resume. Vartalab teaches students how to build a profile, a network and a body of work that gets noticed by the right companies, long before placement season begins. We run this through masterclasses and structured courses, delivered both online and inside colleges, so students graduate with a personal brand and not just a degree.",
    ctaLabel: "Start my LinkedIn journey",
    features: [
      {
        icon: "IdCard",
        title: "Job Ready LinkedIn Profiles",
        description:
          "We rebuild student profiles from headline to featured section so recruiters see real strengths in five seconds.",
      },
      {
        icon: "GraduationCap",
        title: "Personal Branding Masterclasses",
        description:
          "Interactive sessions, on campus or online, that teach students to think, write and post like a young professional.",
      },
      {
        icon: "BookOpen",
        title: "Structured Online Courses",
        description:
          "Self paced modules covering networking, content, outreach and interview visibility on LinkedIn.",
      },
      {
        icon: "School",
        title: "College and Campus Programs",
        description:
          "Workshops delivered directly inside colleges and placement cells, built around each institution's own calendar.",
      },
      {
        icon: "PenSquare",
        title: "Storytelling for Careers",
        description:
          "We turn internships, projects and college life into posts that show initiative, not just information.",
      },
      {
        icon: "Network",
        title: "Placement Focused Networking",
        description:
          "A practical system for reaching alumni, recruiters and hiring managers with messages that actually get replies.",
      },
    ],
  },
  {
    id: "professionals",
    navLabel: "Professionals",
    accent: "#2dd4bf",
    ctaText: "#0b0d12",
    icon: "Sparkles",
    kicker: "Personal Brand and Lead Generation",
    title: "Vartalab for Self Employed Professionals",
    intro:
      "Doctors, coaches, consultants and real estate agents all run on the same currency, trust. Vartalab builds that trust across Instagram, LinkedIn and YouTube with content that sounds like you and looks professional. We shoot, write and edit the content, manage the posting calendar, and turn every follower into a lead that can be nurtured through to an appointment, a consultation or a sale.",
    ctaLabel: "Grow my professional brand",
    features: [
      {
        icon: "Layers",
        title: "Multi Platform Brand Building",
        description:
          "One consistent brand voice designed for Instagram, LinkedIn and YouTube, adapted to how each platform works.",
      },
      {
        icon: "Clapperboard",
        title: "Content Creation and Editing",
        description:
          "From shoot day to final edit, we produce reels, posts and long form videos ready to publish.",
      },
      {
        icon: "CalendarClock",
        title: "Calendar and Posting Management",
        description:
          "We plan, schedule and publish on your behalf so your presence stays consistent even on your busiest weeks.",
      },
      {
        icon: "MapPin",
        title: "Local Authority Building",
        description:
          "Content built around your city, specialty and clients so the right local audience finds and trusts you first.",
      },
      {
        icon: "Magnet",
        title: "Lead Capture and Nurture Systems",
        description:
          "Every piece of content connects to a simple system that captures interest and follows it up until it becomes a client.",
      },
      {
        icon: "MessageSquareQuote",
        title: "Client Story Content",
        description:
          "Real testimonials, case walkthroughs and before and after stories that convert attention into appointments.",
      },
    ],
  },
];

export const differentiators = [
  {
    icon: "UsersRound",
    title: "One team, three specialties",
    description:
      "Leaders, students and independent professionals need different voices. We staff every engagement with people who understand that specific world.",
  },
  {
    icon: "ShieldCheck",
    title: "Content that sounds like you",
    description:
      "Every post, script and caption goes through your review before it goes live, so your voice never gets diluted.",
  },
  {
    icon: "Workflow",
    title: "We own the full pipeline",
    description:
      "Strategy, writing, design, editing, scheduling and posting all happen inside Vartalab, so nothing falls through the cracks between tools.",
  },
  {
    icon: "BadgeCheck",
    title: "Real proof, not stock case studies",
    description:
      "Every testimonial on this site is a real client we have worked with and not a placeholder.",
  },
];

export const team = [
  {
    photo: "/team/kiran-patil.png",
    name: "Kiran Patil",
    role: "Founder and Chief Executive Officer",
    accent: "#3b82f6",
    icon: "Briefcase",
    bio: "Kiran leads content, branding and client strategy at Vartalab. Over seven years, she has built B2B and B2C brands across industries, shaping how founders, companies and professionals are seen and remembered by the people who matter most to their business.",
  },
];

export const testimonials = [
  {
    quote:
      "Our newsletter and digital marketing were inconsistent and forgettable. Vartalab team fixed that. Clear voice, better structure, and our subscribers actually started replying. Noticeable difference within the first month.",
    name: "Kunal Gaikwad",
    role: "Lencor India",
    testid: "testimonial-one",
  },
  {
    quote:
      "The website finally looks and sounds like us. Vartalab understood our business quickly and the copy she wrote is sharp and to the point. Visitors now get what we do instantly. Should have done this sooner.",
    name: "Mahesh Takey",
    role: "CadnCart",
    testid: "testimonial-two",
  },
  {
    quote:
      "LinkedIn was doing nothing for me before Vartalab. Now I get inbound conversations from exactly the right people. Vartalab tied together my personal brand and our digital presence in a way I could not have figured out alone.",
    name: "Vijay Ahire",
    role: "Velemento Technologies",
    testid: "testimonial-three",
  },
];

export const faqs = [
  {
    question: "Which of the three pillars is right for me?",
    answer:
      "If you lead a company, start with Leaders. If you are a student preparing for placements, start with Students. If you run your own practice or business, start with Professionals. On our first call we will confirm the right fit together.",
  },
  {
    question: "Do you work with individuals, colleges and companies?",
    answer:
      "Yes. We work directly with founders and professionals, run structured programs inside colleges, and partner with companies on leadership and employer branding.",
  },
  {
    question: "Which platforms do you manage?",
    answer:
      "LinkedIn is central to everything we do, and depending on your pillar we also manage Instagram, YouTube and email newsletters.",
  },
  {
    question: "Do you write and design everything, or do we?",
    answer:
      "We handle strategy, writing, design and scheduling. You stay in control through a simple approval step before anything is published.",
  },
  {
    question: "How soon can we start?",
    answer:
      "Most engagements begin within two weeks of our first conversation, once we understand your goals and audience.",
  },
  {
    question: "Do students and professionals get the same plan as companies?",
    answer:
      "No. Every pillar has its own process and deliverables built around what that specific audience actually needs.",
  },
];

export const logos = [
  "/logos/logo-1.jpeg",
  "/logos/logo-2.jpeg",
  "/logos/logo-3.jpeg",
  "/logos/logo-4.jpeg",
  "/logos/logo-5.jpeg",
  "/logos/logo-6.jpeg",
  "/logos/logo-7.jpeg",
];
